import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { IonContent, NavController, Platform } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { CustomerModel } from "src/app/models/customer-model";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { WebservicesService } from "src/app/services/webservices/webservices.service";
import {
  coutryPostalMatchValidator,
  POboxValidator,
  POboxValidatorGroup,
  NAME_PATTERN,
  noWhitespaceOnlyValidator,
} from "../../../services/customFormValidators";
import { AddressService } from "src/app/services/address/address.service";
import { map, startWith } from "rxjs/operators";
import { Observable } from "rxjs";
import { isUndefined } from "src/app/services/codeUtils";
import { LogoutService } from "src/app/services/logout/logout.service";
import { GlobalErrorHandlerService } from "src/app/services/global-errors/global-error-handler.service";
import { LoginService } from "src/app/services/login/login.service";

@Component({
  selector: "app-personal-information",
  templateUrl: "./personal-information.component.html",
  styleUrls: ["./personal-information.component.scss"],
})
export class PersonalInformationComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() reconfirmPersonalInfo: any;

  public error: GlobalErrorHandlerService = null;
  public customer: CustomerModel;
  public infoForm: FormGroup;
  public street: AbstractControl;
  public street2: AbstractControl;
  public city: AbstractControl;
  public country: AbstractControl;
  public province: AbstractControl;
  public postalCode: AbstractControl;
  public countryInfoGroup: AbstractControl;
  public streetGroup: AbstractControl;
  public phoneNumber: AbstractControl;
  public sendEmailUponLogin: AbstractControl;
  public allowPromoSms: AbstractControl;
  public allowPromoEmails: AbstractControl;
  public citizenship: AbstractControl;
  public selectedCountry: string;
  public selectedProvince: string;
  public selectedSecurityQuestion: string;
  public selectedCountryCitizenship: string;

  public countries: any[];
  public provinces: any[];
  public securityQuestions: any[];
  public citizenshipCountries: any[];
  public countryChanged: boolean;
  public emailUponLogin: boolean = false;

  public allowPromoSmsCheck: boolean = false;
  public allowPromoEmailsCheck: boolean = false;
  public enableEdit: boolean;
  public updateButtonDisabled: boolean = false;
  public stateProvinceLabel;
  public zipPostalCodeLabel;

  public aliasNameCheck: boolean;
  public citizenshipCheck: boolean;
  public jobIndustryCheck: boolean;
  public employerNameCheck: boolean;
  public employerAddressCheck: boolean;
  public businessPhoneCheck: boolean;

  public aliasName: AbstractControl;
  public employerName: AbstractControl;
  public employerAddress: AbstractControl;
  public businessPhoneNumber: AbstractControl;
  public citizenshipGroup: AbstractControl;
  public descriptiveOccupation: AbstractControl;
  public jobTitle: AbstractControl;
  public industry: AbstractControl;

  jobTitleList: any[];
  jobTitleListObservable: Observable<string[]>;
  holdJobTitleResponse: any[];
  public searchJob: string = '';
  public showJobTitleResults = false;

  jobIndustryList: any[];
  jobIndustryListObservable: Observable<string[]>;
  holdJobIndustryResponse: any[];
  public searchIndustry: string = '';
  public showJobIndustryResults = false;

  editableFieldListArray: Array<any> = [];

  public firstName: AbstractControl;
  public lastName: AbstractControl;
  public middleName: AbstractControl;
  public annualReconfirmation: boolean = false;
  editableFieldListForReconfirmationArray: Array<any> = [];
  refreshed: boolean = false;
  fieldsToBeAdded: Array<any> = [];
  public editableOnce = true;

  formatteReconfirmDate: any;

  constructor(
    public addressService: AddressService,
    public navCtrl: NavController,
    public userSession: UserSessionService,
    public authService: AuthenticationService,
    public successMessageService: SuccessMessageService,
    public events: EventsService,
    public config: ConfigService,
    public utils: UtilsService,
    public webservice: WebservicesService,
    private globalErrorHandlerService: GlobalErrorHandlerService,
    public platform: Platform,
    public logoutService: LogoutService,
    private navigator: Navigator,
    private loginService: LoginService,
  ) {
    this.userSession.getCustomer().subscribe((customer) => {
      if (customer) {
        this.customer = customer;

        if (this.customer.sendEmailUponLogin == true) {
          this.emailUponLogin = true;
        }
        if (this.customer.allowPromoEmails == true) {
          this.allowPromoEmailsCheck = true;
        }
        if (this.customer.allowPromoSms == true) {
          this.allowPromoSmsCheck = true;
        }
      }
    });
    this.userSession.refreshCustomer();
  }

  convertDate(date: any): any {
    // Parse the date string into a Date object
    const dateParts = date.split('/');
    const dateObj = new Date(+dateParts[2], +dateParts[0] - 1, +dateParts[1]);

    // Format the date to yyyy-MM-dd
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObj.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  ngOnInit() {

    this.aliasNameCheck = this.config.getConfig().FEATURE_SIGNUP_SHOW_ALIAS_FIELD === '1' ? true : false;
    this.citizenshipCheck = this.config.getConfig().FEATURE_SIGNUP_SHOW_CITIZEN_FIELD === '1' ? true : false;
    this.jobIndustryCheck = this.config.getConfig().FEATURE_INFOPAGE_SHOW_JOB_INDUSTRY_FIELD === '1' ? true : false;
    this.employerNameCheck = this.config.getConfig().FEATURE_INFOPAGE_SHOW_EMPLOYER_NAME_FIELD === '1' ? true : false;
    this.employerAddressCheck = this.config.getConfig().FEATURE_INFOPAGE_SHOW_EMPLOYER_ADDRESS_FIELD === '1' ? true : false;
    this.businessPhoneCheck = this.config.getConfig().FEATURE_INFOPAGE_SHOW_BUSINESS_PHONE === '1' ? true : false;

    this.selectedCountry = this.config.getConfig().FEATURE_SITE_COUNTRY_REGION ? this.config.getConfig().FEATURE_SITE_COUNTRY_REGION : 'CAN';
    if (this.selectedCountry === 'CANADA') {
      this.stateProvinceLabel = 'Province';
      this.zipPostalCodeLabel = 'Postal Code';
    } else {
      this.stateProvinceLabel = 'State';
      this.zipPostalCodeLabel = 'Zip Code';
    }

    this.infoForm = new FormGroup({
      countryInfoGroup: new FormGroup(
        {
          country: new FormControl("", [Validators.required]),
          postalCode: new FormControl(this.customer?.address?.postalCode, [Validators.required]),
        },
        coutryPostalMatchValidator
      ),
      streetGroup: new FormGroup(
        {
          street: new FormControl(this.customer?.address?.street, [Validators.required, POboxValidator]),
          street2: new FormControl(this.customer.address.street2 ? this.customer.address.street2 : '', [POboxValidator]),
        },
        POboxValidatorGroup
      ),
      city: new FormControl(this.customer?.address?.city, [Validators.required]),
      province: new FormControl("", [Validators.required]),
      /*citizenship: new FormControl(({value: this.customer?.citizenship, disabled: !this.citizenshipCheck}), [
        Validators.required,
        Validators.pattern(NAME_PATTERN),
      ]),*/
      phoneNumber: new FormControl(this.customer?.address?.phoneNumber, [
        Validators.required,
        Validators.pattern("^[0-9]+$"),
        Validators.minLength(10),
        Validators.maxLength(10),
      ]),
      sendEmailUponLogin: new FormControl(""),
      allowPromoSms: new FormControl(""),
      allowPromoEmails: new FormControl(""),
      citizenship: new FormControl(({ value: this.customer?.citizenship ? this.customer?.citizenship : '', disabled: !this.citizenshipCheck }), [Validators.required, Validators.pattern(NAME_PATTERN)]),
      jobTitle: new FormControl(({ value: this.customer?.jobTitle ? this.customer?.jobTitle : '', disabled: !this.jobIndustryCheck }), [Validators.required]),
      industry: new FormControl(({ value: this.customer?.jobIndustry ? this.customer?.jobIndustry : '', disabled: !this.jobIndustryCheck }), [Validators.required]),
      employerName: new FormControl(({ value: this.customer?.employerName ? this.customer?.employerName : '', disabled: !this.employerNameCheck }), [noWhitespaceOnlyValidator, Validators.minLength(1), Validators.maxLength(100)]),
      employerAddress: new FormControl(({ value: this.customer?.employerAddress ? this.customer?.employerAddress : '', disabled: !this.employerAddressCheck }), [noWhitespaceOnlyValidator, Validators.minLength(10), Validators.maxLength(255)]),
      businessPhoneNumber: new FormControl(({ value: this.customer?.businessPhoneNumber ? this.customer?.businessPhoneNumber : '', disabled: !this.businessPhoneCheck }), [Validators.pattern('^[0-9]+$'), Validators.minLength(10), Validators.maxLength(10)]),
      firstName: new FormControl(this.customer?.firstName ? this.customer?.firstName : '', [Validators.required, Validators.pattern(NAME_PATTERN)]),
      lastName: new FormControl(this.customer?.lastName ? this.customer?.lastName : '', [Validators.required, Validators.pattern(NAME_PATTERN)]),
      middleName: new FormControl(this.customer?.middleName ? this.customer?.middleName : '', [Validators.pattern(NAME_PATTERN)]),
      aliasName: new FormControl(this.customer?.nickName ? this.customer?.nickName : '', [Validators.pattern(NAME_PATTERN)]),
    });

    this.enableEdit = this.config.getConfig().ENABLE_CUSTOMER_EDIT == 1 ? true : false;

    this.city = this.infoForm.get("city");
    this.province = this.infoForm.get("province");
    this.phoneNumber = this.infoForm.get("phoneNumber");
    //this.citizenship = this.infoForm.get("citizeship");
    this.sendEmailUponLogin = this.infoForm.get("sendEmailUponLogin");
    this.allowPromoSms = this.infoForm.get("allowPromoSms");
    this.allowPromoEmails = this.infoForm.get("allowPromoEmails");

    this.streetGroup = this.infoForm.get("streetGroup");
    this.street = this.streetGroup.get("street");
    this.street2 = this.streetGroup.get("street2");

    this.countryInfoGroup = this.infoForm.get("countryInfoGroup");
    this.country = this.countryInfoGroup.get("country");
    this.postalCode = this.countryInfoGroup.get("postalCode");

    this.aliasName = this.infoForm.get('aliasName');

    if (this.citizenshipCheck) this.citizenship = this.infoForm.get("citizenship");

    if (this.jobIndustryCheck) this.jobTitle = this.infoForm.get("jobTitle");
    if (this.jobIndustryCheck) this.industry = this.infoForm.get("industry");
    if (this.employerNameCheck) this.employerName = this.infoForm.get('employerName');
    if (this.employerAddressCheck) this.employerAddress = this.infoForm.get('employerAddress');
    if (this.businessPhoneCheck) this.businessPhoneNumber = this.infoForm.get('businessPhoneNumber');


    if (this.jobIndustryCheck) {
      this.jobIndustryListObservable = this.industry.valueChanges.pipe(
        startWith(''),
        map(value => this.searchJobIndustryList(value))
      );
      this.jobTitleListObservable = this.jobTitle.valueChanges.pipe(
        startWith(''),
        map(value => this.searchJobTitleList(value))
      );
    }

    const editableFieldList = this.config.getConfig().FEATURE_PERSONAL_DETAILS_FIELD_EDITABLE ? this.config.getConfig().FEATURE_PERSONAL_DETAILS_FIELD_EDITABLE : "firstName,lastName,middleName,jobTitle,industry,employerName,employerAddress,businessPhoneNumber";
    this.editableFieldListArray = editableFieldList.split(',');

    const editableFieldListForReconfirmationArray = this.config.getConfig().FEATURE_PERSONAL_DETAILS_FIELD_EDITABLE_FOR_RECONFIRMATION ? this.config.getConfig().FEATURE_PERSONAL_DETAILS_FIELD_EDITABLE_FOR_RECONFIRMATION : "firstName,lastName,middleName,phoneNumber,street,street2,city,province,country,postalCode,jobTitle,industry,employerName,employerAddress,businessPhoneNumber";
    this.editableFieldListForReconfirmationArray = editableFieldListForReconfirmationArray.split(',');

    this.fieldsToBeAddedEditStatusCheck()
  }

  fieldsToBeAddedEditStatusCheck() {
    const fieldsToBeAdded = this.config.getConfig().FEATURE_PERSONAL_DETAILS_FIELD_EDITABLE_ONLY_ONCE ? this.config.getConfig().FEATURE_PERSONAL_DETAILS_FIELD_EDITABLE_ONLY_ONCE : "middleName,aliasName";
    this.fieldsToBeAdded = fieldsToBeAdded.split(',');
    this.fieldsToBeAdded.forEach(fieldName => {
      if (this.infoForm.get(fieldName).value) {
        this.infoForm.get(fieldName).disable();
      } else {
        this.infoForm.get(fieldName).enable();
      }
    });
  }

  print(){
    console.log(this.infoForm);
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.updateButtonDisabled = false;
    // this.successMessageService.clearMessage();   //SuccessMessage is not yet implemented. Needs to be added later
    this.error = null;

    if (this.reconfirmPersonalInfo) {
      this.annualReconfirmation = true;
      this.firstName = this.infoForm.get('firstName');
      this.lastName = this.infoForm.get('lastName');
      this.middleName = this.infoForm.get('middleName');
    } else {
      this.annualReconfirmation = false;
      this.infoForm.controls['firstName'].disable();
      this.infoForm.controls['lastName'].disable();
      // this.infoForm.controls['middleName'].disable();
    }
    const reconfirm = this.customer.getCustomDataProperty('NEXT_CUST_DETAILS_RECONFIRMATION_DATE');

    if(localStorage.getItem("reconfirmPopover") === "true"){
      this.annualReconfirmation = true;
      this.infoForm.controls['firstName'].enable();
      this.infoForm.controls['lastName'].enable();
      this.firstName = this.infoForm.get('firstName');
      this.lastName = this.infoForm.get('lastName');
      this.middleName = this.infoForm.get('middleName');
    }else{
      this.annualReconfirmation = false;
      this.infoForm.controls['firstName'].disable();
      this.infoForm.controls['lastName'].disable();
    }

    this.countryChanged = false;
    this.getCitizenshipCountries();
    if (this.jobIndustryCheck) {
      this.initializeJobsTitle();
      this.initializeJobIndustry();
    }

    if (this.jobIndustryCheck) {
      this.infoForm.patchValue({
        jobTitle: this.customer?.jobTitle,
        industry: this.customer?.jobIndustry
      });
    }
  }

  formatDate(dateString: string): Date {
    const [datePart] = dateString.split(' '); 
    
    // Split the date part into month, day, and year
    const [month, day, year] = datePart.split('/').map(Number);
    
    return new Date(year, month - 1, day); 
  }

  isDateLessThan(date1: Date, date2: Date): boolean {
    return date1.getTime() <= date2.getTime();
  }

  ionViewCanLeave() {
    if (
      this.config.getConfig().KYC_CHECK_PLAY == "1" &&
      this.customer.isIncomplete()
    ) {
      this.navigator.navigateTo(
        "LogoutPage",
        {},
        { reason: "EDIT_PROFILE_KYC_FAIL" }
      );
    }
  }

  onChangeCountry(event) {
    this.countryChanged = true;
    this.getProvinces(event);
  }

  getCitizenshipCountries() {
    this.addressService.callGetAllCountries().subscribe({
      next: (response: any) => {
        if (response && !!response.result) {
          const countriesList = response.payload;

          this.countries = [];
          this.citizenshipCountries = [];
          for (let c in countriesList) {
            if ("eligibSts" in countriesList[c]) {
              if (countriesList[c]["eligibSts"] == "ELIGIBLE") {
                this.countries.push(countriesList[c]);
              }
            } else {
              this.countries.push(countriesList[c]);
            }
            this.citizenshipCountries.push(countriesList[c]);
          }

          if (this.countries.length == 1) {
            this.selectedCountry = this.countries[0].code;
            this.country.setValue(this.countries[0].code);
          } else {
            this.selectedCountry = this.customer.address.country;
            this.country.setValue(this.customer.address.country);
          }
          this.updateCountryField();

          // Citizenship countries match with code2
          for (const c in this.citizenshipCountries) {
            if (
              this.citizenshipCountries[c].code2 ===
              this.customer.citizenship ||
              this.citizenshipCountries[c].code === this.customer.citizenship
            ) {
              this.selectedCountryCitizenship =
                this.citizenshipCountries[c].name;
            } else if (
              this.customer.citizenship === this.citizenshipCountries[c].name
            ) {
              this.selectedCountryCitizenship = this.customer.citizenship;
            }
          }
          this.getProvinces(this.selectedCountry);
        }
      },
      error: (error) => {
        console.error("callGetAllCountries ", error);
      }
    });
  }

  public updateCountryField() {
    setTimeout(() => {
      this.refreshed = true;
    }, 500);
  }

  getProvinces(country) {
    this.addressService.callGetStatesByCountry(this.selectedCountry).subscribe({
      next: (response: any) => {
        if (response && !!response.result) {
          const provs = response.payload;

          this.provinces = [];
          for (let p in provs) {
            this.provinces.push({ code: p, name: provs[p] });
          }
          if (this.countryChanged) {
            this.selectedProvince = "";
          } else {
            this.selectedProvince = this.customer.address.state;
          }
        }
      },
      error: (error) => {
        console.error("callGetStatesByCountry ", error);
      }
    });
  }

  onSubmit() {
    localStorage.removeItem("reconfirmPopover")
    this.infoForm.addControl(
      "street",
      new FormControl(this.streetGroup.get("street").value)
    );
    this.infoForm.addControl(
      "street2",
      new FormControl(this.streetGroup.get("street2").value)
    );

    if (this.emailUponLogin == true) {
      this.infoForm.get("sendEmailUponLogin").setValue(1);
    } else {
      this.infoForm.get("sendEmailUponLogin").setValue(0);
    }
    if (this.allowPromoSmsCheck == true) {
      this.infoForm.get("allowPromoSms").setValue(1);
    } else {
      this.infoForm.get("allowPromoSms").setValue(0);
    }

    if (this.allowPromoEmailsCheck == true) {
      this.infoForm.get("allowPromoEmails").setValue(1);
    } else {
      this.infoForm.get("allowPromoEmails").setValue(0);
    }

    this.infoForm.value.clientapp = this.config.getClientApp();
    this.authService.callUpdateAccount(this.infoForm.value).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          this.userSession.refreshCustomer();
          this.successMessageService.setMessage('Your account has been updated');
          this.updateButtonDisabled = true;
          this.error = null;
          this.content.scrollToTop(10);
          this.infoForm.removeControl("street");
          this.infoForm.removeControl("street2");
          this.userSession.refreshCustomer().subscribe((customer: CustomerModel) => {
            if (customer) {
              //this.customer = customer;
              console.log('--is it annualReconfirmation--', this.annualReconfirmation)
              console.log('--user status--', customer.status)
              if (this.annualReconfirmation) {
                setTimeout(() => {
                  this.loginService.clearCustomerReconfirmationPersonalInfo();
                  this.authService.callReconfirmCustomerDetails(true);
                }, 1000);

                setTimeout(() => {
                  if (customer.status == 'KYC_FAIL' && response.payload.kyc_step == 'PENDING_IDSCAN') {
                    this.navigator.navigateTo("IdNowComponent", { forceModal: true }, { idScanURLFromReconfirmation: response.payload.id_scan_url, kycFail: true });
                  }else {
                    this.closeModal();
                  }
                }, 3000);
              }

              this.fieldsToBeAddedEditStatusCheck()
            }
          });
        }
      },
      (error) => {

        switch (error.getErrorCode().toUpperCase()) {
          case "ALREADY_HAS_ACCOUNT":
            error.setErrorMessage(
              "It looks like you may have an account with us already."
            );
            break;
          case "CUSTOMER_IN_BLACKLIST":
            error.setErrorMessage(
              "Cannot create account please contact customer support."
            );
            break;
          case "GOVERNMENT_ID_ALREADY_EXISTS":
            error.setErrorMessage(
              "Cannot update account please verify your data. Contact support if the issue continues."
            );
            break;
          case "INVALID_BIRTHDATE":
            error.setErrorMessage("The birthdate entered is invalid");
            break;
          case "PHONE_ALREADY_EXISTS":
            error.setErrorTitle("Sorry, the phone number cannot be used.");
            error.setErrorMessage("Please enter an alternate number or contact Support for help");
            break;
          case "BAD_CONTENT":
            error.setErrorMessage(error.getErrorMessage());
            break;
          default:
            error.setErrorMessage(error.getErrorMessage());
            break;
        }
        // this.successMessageService.clearMessage();  //SuccessMessage is not yet implemented. Needs to be added later
        this.error = error;
        this.content.scrollToTop(10);
        this.infoForm.removeControl("street");
        this.infoForm.removeControl("street2");
      }
    );
  }

  isNotEditable(fieldName?: string) {
    if (this.reconfirmPersonalInfo || localStorage.getItem("reconfirmPopover") === "true" ) {
      if (this.customer.isActive() && this.editableFieldListForReconfirmationArray.includes(fieldName) || this.fieldsToBeAdded) {
        return false;
      }
      return true;
    } else if (fieldName) {
      if (this.customer.isActive() && this.editableFieldListArray.includes(fieldName)) {
        return false;
      }
      return true;
    } else {
      if (this.customer && this.customer.isActive()) {
        return true;
      }
      return false;
    }

  }

  get isMobile() {
    return this.platform.is("mobile") || this.platform.is("mobileweb")
      ? true
      : false;
  }

  onClose() {
    localStorage.removeItem("reconfirmPopover")
    if (this.reconfirmPersonalInfo || this.annualReconfirmation) {
      this.loginService.clearCustomerReconfirmationPersonalInfo();
      this.authService.callReconfirmCustomerDetails(false);
    }
    return this.navigator.dismissAll();
  }


  onBack = () => {
    this.navigator.back();
  }

  private searchJobIndustryList(_indsutry): string[] {
    if (!!_indsutry || !isUndefined(_indsutry)) {
      const indsutryValue = _indsutry.toLowerCase();
      return this.jobIndustryList.filter(option => option.toLowerCase().includes(indsutryValue));
    } else {
      return this.jobIndustryList;
    }
  }

  private searchJobTitleList(_job): string[] {
    if (!!_job || !isUndefined(_job)) {
      const jobValue = _job.toLowerCase();
      return this.jobTitleList.filter(option => option.toLowerCase().includes(jobValue));
    } else {
      return this.jobTitleList;
    }
  }

  validateJobList() {

    const validateJob = this.jobTitleList.findIndex(item => this.searchJob.toLowerCase() === item.toLowerCase());
    if (validateJob === -1) {
      this.infoForm.get('jobTitle').setErrors({ 'incorrect': true });
    }
    this.showJobList();
  }

  validateIndustryList() {

    const validateIndustry = this.jobIndustryList.findIndex(item => this.searchIndustry.toLowerCase() === item.toLowerCase())
    if (validateIndustry === -1) {
      this.infoForm.get('industry').setErrors({ 'incorrect': true });
    }
    this.showIndustryList();
  }

  initializeJobsTitle() {
    this.addressService.callGetAllJobTitles().subscribe(
      (response: any) => {
        //console.log("callGetAllJobTitles", response);
        if (response && !!response.result) {
          this.holdJobTitleResponse = response.payload;
          this.jobTitleList = this.holdJobTitleResponse.map(({ id, name }) => name);
        }
      },
      (error) => {
        console.log("callGetAllJobTitles ", error);
      }
    )
  }

  fillInJobTitle(title) {
    this.jobTitle.setValue(title);
    this.infoForm.markAsDirty();
    this.showJobTitleResults = false;
    return false;
  }

  hideJobList() {
    this.showJobTitleResults = false;
  }

  showJobList() {
    this.showJobTitleResults = true;
  }

  initializeJobIndustry() {
    this.addressService.callGetAllJobIndustries().subscribe(
      (response: any) => {
        //console.log("callGetAllJobIndustries", response);
        if (response && !!response.result) {
          this.holdJobIndustryResponse = response.payload;
          this.jobIndustryList = this.holdJobIndustryResponse.map(({ id, name }) => name);
        }
      },
      (error) => {
        console.log("callGetAllJobIndustries ", error);
      }
    )
  }

  fillInJobIndustry(title) {
    this.industry.setValue(title);
    this.showJobIndustryResults = false;
    this.infoForm.markAsDirty();
    return false;
  }

  hideIndustryList() {
    this.showJobIndustryResults = false;
  }

  showIndustryList() {
    this.showJobIndustryResults = true;
  }

  closeModal = () => {
    localStorage.removeItem("reconfirmPopover")
    if (this.reconfirmPersonalInfo && this.customer.status === 'KYC_FAIL') {
      this.logoutService.onLogout({ reason: "RECONFIRMATION_UPLOAD_DOCUMENT_VERIFICATION_PENDING" });
    } else {
      if (this.reconfirmPersonalInfo) {
        this.loginService.clearCustomerReconfirmationPersonalInfo();
        this.authService.callReconfirmCustomerDetails(false);
      }
      this.navigator.dismissAll();
    }
  }
}
